import React from "react"
import { Helmet } from "react-helmet"
import { useLocation } from "@reach/router"
import { useStaticQuery, graphql } from "gatsby"
const SEO = ({ title, description, noIndex = false, noFollow = false }) =>
{
  const { pathname } = useLocation()
  const { site, datoCmsDefault } = useStaticQuery(query)
  const {
    defaultTitle,
    defaultDescription,
    // defaultImage,
    // twitterUsername,
  } = site.siteMetadata
  const {
    siteUrl
  } = datoCmsDefault
  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    // image: `${siteUrl}${image || defaultImage}`,
    url: `${siteUrl}${pathname}`,
  }
  return (
    <Helmet title={seo.title}>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      {seo.url && <meta property="og:url" content={seo.url} />}
      {/* {(article ? true : null) && <meta property="og:type" content="article" />} */}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}
      {/* {seo.image && <meta property="og:image" content={seo.image} />} */}
      {/* <meta name="twitter:card" content="summary_large_image" /> */}
      {/* {twitterUsername && (
        <meta name="twitter:creator" content={twitterUsername} />
      )} */}
      {seo.title && <meta name="twitter:title" content={seo.title} />}
      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}
      {noFollow && <meta name="robots" content="nofollow" />}
      {noIndex && <meta name="robots" content="noindex" />}
      {/* {gtmId && <script dangerouslySetInnerHTML={{ __html:" datoCmsDefault.gtmHead" }} />} */}

      {/* {seo.image && <meta name="twitter:image" content={seo.image} />} */}
      <script src="https://unpkg.com/@botpoison/browser"></script>
    </Helmet>
  )
}
export default SEO
// SEO.propTypes = {
//   title: PropTypes.string,
//   description: PropTypes.string,
//   image: PropTypes.string,
//   article: PropTypes.bool,
// }
// SEO.defaultProps = {
//   title: null,
//   description: null,
//   image: null,
//   article: false,
// }
const query = graphql`
  query SEO {
    site {
      siteMetadata {
        defaultTitle: title
        defaultDescription: description
        # siteUrl: siteURL
        # defaultImage: image
        # twitterUsername
      }
    }
    datoCmsDefault {
      siteUrl
    }
  }
`